/* ============================================================
   APEX MALE — Free gift with purchase (no cart reload)
   Includes a £0 gift product (the Getting-Started e-book) with any purchase:

   1. On any Add-to-Cart submit, a `keepalive` request pre-adds the gift so it
      is usually already in the cart when the customer reaches /cart.
   2. On /cart it reconciles the cart (adds the gift if missing, drops a lone
      gift, caps qty at 1) and refreshes the cart display IN PLACE using
      Shopify's Section Rendering API — no full-page reload, so the checkout
      button is never yanked out from under the customer.

   Driven by window.ApexFreeGift = { variantId, handle, price }, emitted by
   theme.liquid ONLY when enabled AND the gift is genuinely £0.

   SAFETY: only ever manages a £0.00 line — never adds/removes a paid item.
   Limitation: express wallets that skip /cart (Shop Pay on a PDP) aren't
   covered by a theme-only free gift (needs Shopify Functions).
   ============================================================ */
(function () {
  var cfg = window.ApexFreeGift;
  if (!cfg || !cfg.variantId) return;
  if (Number(cfg.price) !== 0) return; // never manage a paid product

  var GIFT_ID = Number(cfg.variantId);
  var GIFT_HANDLE = cfg.handle || '';

  function onCartPage() {
    return location.pathname.replace(/\/+$/, '').endsWith('/cart');
  }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function addGift(useKeepalive) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: GIFT_ID, quantity: 1 }] }),
      keepalive: !!useKeepalive
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }
  function changeGiftQty(qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(GIFT_ID), quantity: qty })
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }

  // (1) Pre-add the gift alongside ANY Add-to-Cart submit. keepalive lets the
  //     request finish even as product-form.js redirects to /cart.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || (form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    addGift(true);
  }, true);

  function giftRowInDom() {
    var rows = document.querySelectorAll('.cart-item');
    for (var i = 0; i < rows.length; i++) {
      var l = rows[i].querySelector('a[href*="/products/"]');
      if (l && (l.getAttribute('href') || '').indexOf('/products/' + GIFT_HANDLE) !== -1) return true;
    }
    return false;
  }

  // Refresh the cart items + footer IN PLACE via the Section Rendering API.
  function refreshCart() {
    var itemsEl = document.getElementById('main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');
    var ids = [];
    if (itemsEl && itemsEl.dataset.id) ids.push(itemsEl.dataset.id);
    if (footerEl && footerEl.dataset.id) ids.push(footerEl.dataset.id);
    if (!ids.length) return Promise.resolve();
    // A no-op cart update that asks Shopify to render the cart sections, so we
    // can swap them into the page in place (no full reload).
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ sections: ids.join(','), sections_url: '/cart' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var sections = data.sections || {};
        [itemsEl, footerEl].forEach(function (el) {
          if (!el || !el.dataset.id || !sections[el.dataset.id]) return;
          var parsed = new DOMParser().parseFromString(sections[el.dataset.id], 'text/html');
          var src = parsed.querySelector('.js-contents');
          var dst = el.querySelector('.js-contents');
          if (src && dst) dst.innerHTML = src.innerHTML;
        });
        var body = document.querySelector('.cart, .cart__contents');
        if (body) body.classList.remove('is-empty');
      })
      .catch(function () {});
  }

  function updateCountBubble(count) {
    var bubbles = document.querySelectorAll('.apex-cart__bubble, .cart-count-bubble span[aria-hidden]');
    for (var i = 0; i < bubbles.length; i++) bubbles[i].textContent = count;
  }

  // (2) Reconcile on /cart — never reloads.
  function reconcile() {
    return getCart().then(function (cart) {
      var items = (cart && cart.items) || [];
      var gift = null, qualifying = 0;
      items.forEach(function (i) { if (i.variant_id === GIFT_ID) gift = i; else qualifying += 1; });

      if (gift && (gift.final_price > 0 || gift.price > 0)) return decorateGiftLine(); // never touch a paid line

      if (qualifying > 0 && !gift) return addGift(false).then(function () { return refreshCartAndCount(); });
      if (qualifying === 0 && gift) return changeGiftQty(0).then(function () { return refreshCartAndCount(); });
      if (gift && gift.quantity !== 1) return changeGiftQty(1).then(function () { return refreshCartAndCount(); });
      if (gift && !giftRowInDom()) return refreshCartAndCount(); // race: in cart data but not yet shown
      return decorateGiftLine();
    }).catch(function () {});
  }

  function refreshCartAndCount() {
    return refreshCart().then(function () {
      return getCart().then(function (c) { updateCountBubble(c.item_count); decorateGiftLine(); });
    });
  }

  // Badge the gift row "FREE GIFT" + show price as FREE (CSS locks its controls).
  function decorateGiftLine() {
    if (!GIFT_HANDLE) return;
    var rows = document.querySelectorAll('.cart-item');
    for (var n = 0; n < rows.length; n++) {
      var link = rows[n].querySelector('a[href*="/products/"]');
      var href = link ? link.getAttribute('href') || '' : '';
      if (href.indexOf('/products/' + GIFT_HANDLE) !== -1) {
        rows[n].classList.add('apex-cart__gift');
        var prices = rows[n].querySelectorAll('.cart-item__price-wrapper .price, .price');
        for (var p = 0; p < prices.length; p++) prices[p].textContent = 'FREE';
      }
    }
  }

  function run() { if (onCartPage()) reconcile(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-badge after Dawn re-renders cart items (quantity edits on the cart page).
  if (onCartPage() && 'MutationObserver' in window) {
    var list = document.querySelector('.cart-items') || document.querySelector('cart-items');
    if (list) new MutationObserver(decorateGiftLine).observe(list, { childList: true, subtree: true });
  }
})();
